import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import Divider from 'material-ui/Divider';
import { translate } from 'react-i18next';

import NotesTable from '../components/NotesTable';
import PageBase from '../components/PageBase';
import PacketboxForm from '../components/PacketboxForm';
import * as packetboxActions from '../redux/modules/packetboxes';
import * as endUserActions from '../redux/modules/endUsers';
import i18n from '../translations/i18n';

/*
PropTypes / DefaultProps
 */
const propTypes = {
  modifyPacketbox: PropTypes.func,
  fetchPacketbox: PropTypes.func,
  packetbox: PropTypes.object,
  tanRegenerating: PropTypes.bool,
  t: PropTypes.func,
  params: PropTypes.any,
  unloadCurrentPacketbox: PropTypes.any,
  modifyNote: PropTypes.func,
  fetchNotes: PropTypes.func,
  fetchPacketboxKeys: PropTypes.func,
  fetchEndUsers: PropTypes.func,
  regenerateTan: PropTypes.func,
  createNote: PropTypes.func,
  packetboxKeys: PropTypes.any,
  currentUser: PropTypes.any,
  endUsers: PropTypes.any,
};

const defaultProps = {
  packetbox: {},
  tanRegenerating: false,
};

class PacketboxModify extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      packetbox: null,
    };
    this.id = this.props.params.splat;
  }
  /*
    Lifecycle methods
   */

  componentWillMount() {
    this.fetchData();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.packetbox) {
      this.setState({
        packetbox: nextProps.packetbox,
      });
    }

    if (this.props.tanRegenerating === true && nextProps.tanRegenerating === false) {
      this.fetchData();
    }
  }

  componentWillUnmount() {
    this.props.unloadCurrentPacketbox();
  }

  /*
    Custom methods
   */
  onModifyPacketbox = (values) => {
    delete values.version;
    this.props.modifyPacketbox(values);
  };

  onRegenerateTan = () => {
    this.props.regenerateTan(this.id);
  };

  fetchNotes = () => {
    this.props.fetchNotes(this.id);
  };

  fetchData = () => {
    this.props.fetchPacketbox(this.id);
    this.props.fetchPacketboxKeys(this.id);
    this.props.fetchEndUsers();
    this.fetchNotes();
  };

  saveNote = (note) => {
    note.paketbox_id = this.id;
    if (note.id) {
      this.props.modifyNote(note);
    } else {
      this.props.createNote(note);
    }
  };

  render() {
    const { packetboxKeys, currentUser } = this.props;
    const packetbox = this.state.packetbox;

    let endUsers = [];
    if (this.props.endUsers) {
      endUsers = Object.values(this.props.endUsers);
    }

    if (packetbox && !packetbox.alert_frequency_days) {
      packetbox.alert_frequency_days = 7;
    }

    let notes = [];
    if (packetbox && packetbox.notes) {
      notes = Object.values(packetbox.notes);
    }

    return (
      <PageBase title={this.props.t('modify_paketbox')}>
        <div>
          <div className="row">
            <div className="col-xs-12">
              <div className="box">
                <PacketboxForm
                  onSubmit={this.onModifyPacketbox}
                  onRegenerateTan={this.onRegenerateTan}
                  isModify
                  packetbox={this.state.packetbox}
                  initialValues={this.state.packetbox}
                  packetboxKeys={packetboxKeys}
                  endUsers={endUsers}
                />
              </div>
            </div>
          </div>
          <Divider />
          <br />
          <div className="row">
            <div className="col-xs-12">
              <div className="box">
                <NotesTable
                  notes={notes}
                  onChange={this.fetchNotes}
                  onNoteSave={this.saveNote}
                  currentUserId={currentUser.id}
                />
              </div>
            </div>
          </div>
        </div>
      </PageBase>
    );
  }
}

PacketboxModify.defaultProps = defaultProps;
PacketboxModify.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    packetbox: state.packetboxes.current,
    packetboxKeys: state.packetboxes.currentKeys,
    endUsers: state.endUsers.entities,
    endUsersKeys: state.endUsers.entities,
    translate: getTranslate(state.locale),
    currentUser: state.auth.current,
    tanRegenerating: state.packetboxes.tanRegenerating,
  };
}

const actions = Object.assign({}, endUserActions, packetboxActions);

const extended = translate(['translations'], { i18n })(PacketboxModify);
export default connect(mapStateToProps, actions)(extended);



// WEBPACK FOOTER //
// ./src/containers/PacketboxModify.js